'use client'

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";

interface WorkGalleryProps {
  images: string[];
}

export function WorkGallery({ images }: WorkGalleryProps) {
  // Featured images in specific order
  const featuredFilenames = [
    'A7400587 2.jpg',
    'alan 2.PNG',
    'bbys 2.PNG',
    'IMG_0084.JPG',
    'IMG_4366.JPG',
    'MS 2.jpg'
  ];
  
  // Filter and order images to match featured list
  const displayImages = featuredFilenames
    .map(filename => images.find(img => img.includes(filename)))
    .filter(Boolean) as string[];

  return (
    <section className="bg-white pt-16 md:pt-24">
        <div className="mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10 pb-16 md:pb-24">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 uppercase leading-tight" style={{ color: 'rgb(29,29,31)', fontFamily: '"Universal Sans Display", -apple-system, Arial, sans-serif', letterSpacing: '0.025em' }}>
            <span className="font-bold">You become family,</span>
            <span className="font-light"> not just another client.</span>
          </h2>
          <p className="text-base md:text-lg" style={{ color: 'rgba(0,0,0,0.88)' }}>
            A glimpse into our latest projects and creative executions.
          </p>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-8">
          {displayImages.map((imagePath, index) => (
            <div
              key={imagePath}
              className="relative aspect-[3/4] rounded-2xl md:rounded-3xl overflow-hidden group cursor-pointer"
            >
              <Image
                src={imagePath}
                alt={`Work ${index + 1}`}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                priority={index < 3}
                loading={index < 3 ? "eager" : "lazy"}
                quality={85}
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
            </div>
          ))}
        </div>

        {/* View More Button */}
        {images.length > displayImages.length && (
          <div className="text-center mt-12">
            <Button asChild variant="default" className="px-8" style={{ backgroundColor: '#171A20', color: 'white' }}>
              <Link href="/our-work">
                View All Work
              </Link>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}

